var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#323130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0589 4.44511C11.347 3.73063 10.147 3.90829 9.67261 4.79839L7.6526 8.58878L4.8419 9.52568C4.6775 9.58048 4.5532 9.71649 4.51339 9.88514C4.47357 10.0538 4.52392 10.231 4.64646 10.3536L6.79287 12.5L4.14637 15.1465L4 16L4.85348 15.8536L7.49998 13.2071L9.64646 15.3536C9.76899 15.4761 9.94623 15.5265 10.1149 15.4866C10.2835 15.4468 10.4196 15.3225 10.4744 15.1581L11.4114 12.3469L15.1897 10.3242C16.0759 9.84982 16.2538 8.6551 15.5443 7.94305L12.0589 4.44511Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.20ce1af5369ea31608b96fc744033cb5.svg";
export { ForwardRef as ReactComponent };